<template>
  <form @submit.prevent="submit">
    <div class="az_prfl_mod_photo">
      <label class="az_prfl_mod_photo_img fx-c">
        <input
          id="userCrudPhotoUpload"
          type="file"
          accept="image/*"
          hidden
          @change="uploadPhoto"
        />

        <img
          class="img"
          v-if="model.photoUrl"
          key="img"
          :src="$store.state.url + model.photoUrl"
        />
        <img class="prvw" v-else key="prvw" src="/img/svg/sidebar_user.svg" />
      </label>

      <label
        class="az_prfl_mod_photo_txt del"
        v-if="model.photoUrl"
        key="del"
        @click="deletePhoto"
      >
        <span class="txt">{{ $t("delete") }}</span>
        <i class="fa fa-minus-circle"></i>
      </label>
      <label
        class="az_prfl_mod_photo_txt"
        for="userCrudPhotoUpload"
        v-else
        key="upl"
      >
        <span class="txt">{{ $t("profileMenuModal.uploadPhoto") }}</span>
        <i class="fa fa-plus-circle"></i>
      </label>
    </div>


		<base-input-organization
			class="az_base_form_gr"
			v-if="!edit && $store.state.userProfile.systemAdmin"
			:input-class="{'is-invalid': $v.model.user.uui.$error}"
			:value.sync="$v.model.user.uui.$model"
		></base-input-organization>

    <div class="az_base_form_gr">
      <label class="az_base_lbl">{{ $tc("menu.role", 2) }}</label>
      <div
        class="az_base_inp_role"
        :class="{ 'is-invalid': $v.modelSecond.roles.$error }"
      >
        <label class="az_base_inp_role_badge" v-for="item in roleList">
          <input
            class="inp"
            type="checkbox"
            hidden
            :value="item.id"
            v-model="$v.modelSecond.roles.$model"
          />
          <div class="bt">{{ item.roleName }}</div>
        </label>
      </div>
    </div>

    <div class="az_base_form_gr">
      <label class="az_base_lbl">{{ $t("userName") }}</label>
      <input
        class="form-control az_base_inp"
        type="text"
        :class="{ 'is-invalid': $v.model.user.userName.$error }"
        v-model.trim="$v.model.user.userName.$model"
        v-lowercase
      />
    </div>

    <div class="az_base_form_gr" v-if="!edit">
      <label class="az_base_lbl">{{ $t("password") }}</label>
      <div class="az_base_inp_pass">
        <input
          class="form-control az_base_inp"
          :type="passwordShow ? 'text' : 'password'"
          :class="{ 'is-invalid': $v.model.user.password.$error }"
          v-model="$v.model.user.password.$model"
        />

        <button
          class="bt"
          type="button"
          tabindex="-1"
          @click="passwordShow = !passwordShow"
        >
          <i class="fa fa-eye-slash" v-if="passwordShow"></i>
          <i class="fa fa-eye" v-else></i>
        </button>
      </div>
    </div>

    <div class="az_base_form_gr">
      <label class="az_base_lbl">{{ $t("email") }}</label>
      <input
        class="form-control az_base_inp"
        type="email"
        :class="{ 'is-invalid': $v.model.user.email.$error }"
        v-model.trim="$v.model.user.email.$model"
      />
    </div>

    <base-input-phone
      class="az_base_form_gr"
      :input-class="{ 'is-invalid': $v.model.user.phoneNumber.$error }"
      :value.sync="$v.model.user.phoneNumber.$model"
    ></base-input-phone>

    <div class="az_base_form_gr">
      <label class="az_base_lbl">{{ $t("firstName") }}</label>
      <input
        class="form-control az_base_inp"
        type="text"
        :class="{ 'is-invalid': $v.model.firstName.$error }"
        v-model.trim="$v.model.firstName.$model"
      />
    </div>

    <div class="az_base_form_gr">
      <label class="az_base_lbl">{{ $t("lastName") }}</label>
      <input
        class="form-control az_base_inp"
        type="text"
        :class="{ 'is-invalid': $v.model.lastName.$error }"
        v-model.trim="$v.model.lastName.$model"
      />
    </div>

    <div class="az_base_form_gr">
      <label class="az_base_lbl">{{ $t("middleName") }}</label>
      <input
        class="form-control az_base_inp"
        type="text"
        v-model.trim="model.middleName"
      />
    </div>

    <base-input-deadline
      class="az_base_form_gr"
      :label-text="$t('birthday')"
      disable-from
      :value.sync="model.birthDate"
    ></base-input-deadline>

    <div class="az_base_form_gr">
      <label class="az_base_lbl">{{ $tc("menu.company", 1) }}</label>
      <select
        class="form-control az_base_inp"
        :class="{ 'is-invalid': $v.model.user.companyId.$error }"
        v-model="$v.model.user.companyId.$model"
      >
        <option v-for="item in companies" :value="item.id"
          >{{ item.name }}
        </option>
      </select>
    </div>
    <div class="az_base_form_gr">
      <label class="az_base_lbl">{{ $tc("menu.office", 1) }}</label>
      <select
        class="form-control az_base_inp"
        :class="{ 'is-invalid': $v.model.user.officeId.$error }"
        v-model="$v.model.user.officeId.$model"
      >
        <option v-for="item in offices" :value="item.id"
          >{{ item.name }}
        </option>
      </select>
    </div>
    <div class="az_base_form_gr">
      <label class="az_base_lbl">{{ $tc("menu.department", 1) }}</label>
      <select
        class="form-control az_base_inp"
        :class="{ 'is-invalid': $v.model.user.departmentId.$error }"
        v-model="$v.model.user.departmentId.$model"
      >
        <option v-for="item in departments" :value="item.id"
          >{{ item.name }}
        </option>
      </select>
    </div>

    <button class="btn az_base_btn btn-primary" type="submit">
      <i class="fa fa-save mr-1"></i>
      {{ $t("save") }}
    </button>
  </form>
</template>

<script>
import BaseInputPhone from "../../../../components/BaseInputPhone";
import BaseInputDeadline from "../../../../components/BaseInputDeadline";
import BaseInputOrganization from "../../../../components/BaseInputOrganization";
import { required, email, minLength, helpers } from "vuelidate/lib/validators";
import notification from "@/plugins/vue-notification-config";

const notZero = value => +value !== 0;

export default {
  name: "TheForm",
  components: {
    BaseInputOrganization,
    BaseInputDeadline,
    BaseInputPhone
  },
  props: {
    model: {
      type: Object,
      required: true
    },
    modelSecond: {
      type: Object,
      required: true
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      roleList: [],
      departments: [],
      companies: [],
      offices: [],
      passwordShow: false
    };
  },
  validations() {
    let options = {
      model: {
        firstName: {
          required
        },
        lastName: {
          required
        },
        user: {
          userName: {
            required,
            isNameValid(value) {
              return /^[a-z.0-9_]*$/i.test(value);
            }
          },
          email: {
            required,
          },
          phoneNumber: {
            required,
            minLength: minLength(9)
          },
          companyId: {},
          officeId: {},
          departmentId: {}
        }
      },
      modelSecond: {
        roles: {
          required
        }
      }
    };

    if (!this.edit) {
      options.model.user.password = {
        required
      };

			if (this.$store.state.userProfile.systemAdmin) {
				options.model.user.uui = {
					notZero,
				};
			}
		}

		return options;
	},
	watch: {
		"model.user.companyId"(val) {
			this.getOfficesByCompanyId(val)
		},
		"model.user.officeId"(val) {
			this.getDepartmentsByOfficeId(val)
		},
		'model.user.uui'(val) {
			if (this.$store.state.userProfile.systemAdmin) {
				if (!this.edit) {
					this.modelSecond.roles = [];
					this.roleList = [];
				}

				this.getRoleAll(val);
			}
		}
	},
	mounted() {
		this.getCompanies()
		if (!this.$store.state.userProfile.systemAdmin) {
			this.getRoleAll();
		}
	},
	methods: {
		async getCompanies() {
			try {
				const {data: {data}} = await this.$api.get('companies')
				this.companies = data
			} catch (e) {
				notification.error()
			}
		},
		async getOfficesByCompanyId(companyId) {
			try {
				const {data: {data}} = await this.$api.get('offices', {
					params: {
						companyId
					}
				})
				this.offices = data
			} catch (e) {
				notification.error()
			}
		},
		async getDepartmentsByOfficeId(officeId) {
			try {
				const {data: {data}} = await this.$api.get('departments', {
					params: {
						officeId
					}
				})
				this.departments = data
			} catch (e) {
				notification.error()
			}
		},
		submit() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				return;
			}

			this.$emit('emit:submit');
		},
		getRoleAll(uui = 0) {
			this.$api
				.get('roles', {
					params: {
						uui: uui,
					}
				})
				.then(response => {
					this.roleList = response.data.data;
				});
		},
		uploadPhoto(event) {
			if (event.target.files.length === 0) {
				return;
			}

      let formData = new FormData();
      formData.append("file", event.target.files[0]);

      this.$store.state.loader = true;
      this.$api
        .post("/resource/upload/file", formData, {
          params: {
            minWidth: 100,
            minHeight: 100
          }
        })
        .then(response => {
          this.model.photoUrl = response.data.data.url;
          this.model.resourceFile.id = response.data.data.id;
        })
        .finally(() => {
          event.target.value = "";
          this.$store.state.loader = false;
        });
    },
    deletePhoto() {
      this.model.photoUrl = "";
      this.model.resourceFile.id = null;
    }
  }
};
</script>
